export enum FeedbackType {
	Defect = 'defect',
	Improvement = 'improvement'
}

export interface FeedbackForm {
	appName: string;
	type: FeedbackType;
	email: string;
	summary: string;
	description: string;
	fileName: string;
	includeInfo: boolean;
}
